/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} History_Transfer_Done_TitleInputs */

const en_us2_history_transfer_done_title = /** @type {(inputs: History_Transfer_Done_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`History imported`)
};

const pt_br2_history_transfer_done_title = /** @type {(inputs: History_Transfer_Done_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Histórico importado`)
};

const es_419_history_transfer_done_title = /** @type {(inputs: History_Transfer_Done_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Historial importado`)
};

const pt_pt2_history_transfer_done_title = /** @type {(inputs: History_Transfer_Done_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Histórico importado`)
};

const fr_fr2_history_transfer_done_title = /** @type {(inputs: History_Transfer_Done_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Historique importé`)
};

const de_de2_history_transfer_done_title = /** @type {(inputs: History_Transfer_Done_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verlauf importiert`)
};

const it_it2_history_transfer_done_title = /** @type {(inputs: History_Transfer_Done_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Storico importato`)
};

/**
* | output |
* | --- |
* | "History imported" |
*
* @param {History_Transfer_Done_TitleInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const history_transfer_done_title = /** @type {((inputs?: History_Transfer_Done_TitleInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<History_Transfer_Done_TitleInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_history_transfer_done_title(inputs)
	if (locale === "es-419") return es_419_history_transfer_done_title(inputs)
	if (locale === "pt-PT") return pt_pt2_history_transfer_done_title(inputs)
	if (locale === "fr-FR") return fr_fr2_history_transfer_done_title(inputs)
	if (locale === "de-DE") return de_de2_history_transfer_done_title(inputs)
	if (locale === "it-IT") return it_it2_history_transfer_done_title(inputs)
	return en_us2_history_transfer_done_title(inputs)
});
export { history_transfer_done_title as "history-transfer.done_title" }